<template>
  <div class="view" ref="chart"></div>
</template>

<script>
  export default {
    name: "pie.vue",
    props:[
      'salesAndReview'
    ],
    data(){
      return {
        option : {
          title: {
            text: '销量与评论数',
            subtext: '比例表',
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: '50%',
              label:{
                normal:{
                  show:true,
                  formatter: '{b}:{c}({d}%)'
                }
              },
              data: [
                { value: 1048, name: '销量' },
                { value: 735, name: '评论数' },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      }
    },
    methods:{},
    mounted() {
      this.echartInstance = this.$chart.init(this.$refs['chart'])
      this.option.title.subtext = this.salesAndReview.name
      this.option.series[0].data = [
        {
          value:this.salesAndReview.sales,
          name:'销量'
        },
        {
          value:this.salesAndReview.review,
          name:'评论数'
        }
      ]
      this.echartInstance.setOption(this.option)
    }
  }
</script>

<style scoped>
  .view {
    background: #ffffff;
    width: 400px;
    height: 300px;
  }
</style>
